export default function initializeProductVariationSelection() {
  jQuery(function ($) {
    const variationForms = $('.variations_form');
    const formStates = new WeakMap();

    const getVariations = ($form) => {
      const variations = $form.data('product_variations');

      if (Array.isArray(variations)) {
        return variations;
      }

      try {
        return JSON.parse($form.attr('data-product_variations') || '[]');
      } catch (error) {
        return [];
      }
    };

    const isAvailableVariation = (variation) =>
      variation &&
      variation.variation_is_active !== false &&
      variation.variation_is_visible !== false &&
      (variation.is_purchasable !== false || variation.udm_rental === true) &&
      variation.is_in_stock !== false;

    const isPaperVariation = (variation) =>
      ['attribute_pa_format', 'attribute_format'].some(
        (attribute) =>
          String((variation.attributes || {})[attribute] || '')
            .trim()
            .toLowerCase() === 'papier'
      );

    const getAvailableVariations = ($form) =>
      getVariations($form).filter(isAvailableVariation);

    const getFormState = ($form) => {
      const form = $form.get(0);

      if (!formStates.has(form)) {
        formStates.set(form, {
          notifying: false,
          syncing: false,
          version: 0,
        });
      }

      return formStates.get(form);
    };

    const selectedAttributes = ($form) => {
      const selected = {};

      $form.find('select[name^="attribute_"]').each(function () {
        selected[this.name] = $(this).val() || '';
      });

      return selected;
    };

    const variationMatches = (variation, selected, ignoredAttribute) =>
      (ignoredAttribute === 'attribute_pa_format' &&
        (variation.udm_rental === true ||
          selected.attribute_pa_format === 'location')) ||
      Object.keys(selected).every((attribute) => {
        if (attribute === ignoredAttribute || !selected[attribute]) {
          return true;
        }

        const value = String((variation.attributes || {})[attribute] || '');
        return !value || value === selected[attribute];
      });

    const syncRadio = ($item, value) => {
      $item
        .find('.productAttributeRadios input[type="radio"]')
        .each(function () {
          const $radio = $(this);
          const selected = $radio.val() === value;
          $radio.prop('checked', selected);
        });
    };

    const setAttributeValue = ($form, attribute, value) => {
      const $select = $form.find(`select[name="${attribute}"]`);

      if (!$select.length) {
        return false;
      }

      const safeValue = String(value || '');
      const changed = String($select.val() || '') !== safeValue;
      // WooCommerce removes incompatible options; restore known values on a format change.
      const $option = $select.find('option').filter(function () {
        return this.value === safeValue;
      });
      if (safeValue && !$option.length) {
        const $radio = $select
          .closest('[data-variation-attribute]')
          .find('input[type="radio"]')
          .filter(function () {
            return this.value === safeValue;
          });
        const label = $radio.next('label').text().trim() || safeValue;
        $select.append(new Option(label, safeValue));
      }
      $select.val(safeValue);
      syncRadio($select.closest('[data-variation-attribute]'), safeValue);
      return changed;
    };

    const variationMatchesExactSelection = (variation, selected) =>
      Object.keys(selected).every((attribute) => {
        if (!selected[attribute]) {
          return true;
        }

        return (
          String((variation.attributes || {})[attribute] || '') ===
          selected[attribute]
        );
      });

    const chooseInitialVariation = ($form) => {
      const selected = selectedAttributes($form);
      const variations = getAvailableVariations($form);
      const query = new URLSearchParams(window.location.search);
      const requested = {};
      Object.keys(selected).forEach((attribute) => {
        if (query.has(attribute)) {
          requested[attribute] = query.get(attribute);
        }
      });
      const requestedVariation = variations.find((candidate) => {
        return (
          Object.keys(requested).length > 0 &&
          variationMatchesExactSelection(candidate, requested)
        );
      });
      const variation =
        requestedVariation ||
        variations.find(isPaperVariation) ||
        variations.find((candidate) =>
          variationMatchesExactSelection(candidate, selected)
        ) ||
        variations.find((candidate) => variationMatches(candidate, selected)) ||
        variations[0];

      if (!variation) {
        return;
      }

      Object.keys(selected).forEach((attribute) => {
        setAttributeValue(
          $form,
          attribute,
          String((variation.attributes || {})[attribute] || '')
        );
      });
    };

    const stabilizeSelections = ($form, lockedAttribute) => {
      const attributes = Object.keys(selectedAttributes($form));
      const variations = getAvailableVariations($form);
      let shouldContinue = true;
      let iteration = 0;

      while (shouldContinue && iteration <= attributes.length) {
        shouldContinue = false;
        iteration += 1;

        attributes.forEach((attribute) => {
          if (attribute === lockedAttribute) {
            return;
          }

          const selected = selectedAttributes($form);
          const compatible = variations.filter((variation) =>
            variationMatches(variation, selected, attribute)
          );
          const values = [
            ...new Set(
              compatible
                .map((variation) =>
                  String((variation.attributes || {})[attribute] || '')
                )
                .filter(Boolean)
            ),
          ];
          const hasEmptyValue = compatible.some(
            (variation) =>
              String((variation.attributes || {})[attribute] || '') === ''
          );
          const currentValue = selected[attribute] || '';
          let nextValue = currentValue;

          if (!values.length) {
            nextValue = '';
          } else if (
            currentValue &&
            !hasEmptyValue &&
            !values.includes(currentValue)
          ) {
            nextValue = '';
          } else if (!currentValue && values.length === 1 && !hasEmptyValue) {
            [nextValue] = values;
          }

          if (nextValue !== currentValue) {
            setAttributeValue($form, attribute, nextValue);
            shouldContinue = true;
          }
        });
      }
    };

    const updateAttributeVisibility = ($form) => {
      const selected = selectedAttributes($form);
      const variations = getAvailableVariations($form);

      $form.find('[data-variation-attribute]').each(function () {
        const $item = $(this);
        const attribute = $item.attr('data-variation-attribute');
        const compatible = variations.filter((variation) =>
          variationMatches(variation, selected, attribute)
        );
        const isPresent = compatible.some(
          (variation) =>
            String((variation.attributes || {})[attribute] || '') !== ''
        );

        const rentalOnly =
          attribute !== 'attribute_pa_format' &&
          attribute !== 'attribute_reference-de-location' &&
          compatible.length > 0 &&
          compatible.every((variation) => variation.udm_rental === true);
        const purchaseOnly =
          attribute === 'attribute_reference-de-location' &&
          compatible.every((variation) => variation.udm_rental !== true);
        $item.toggle(isPresent && !rentalOnly && !purchaseOnly);
        $item
          .find('.productAttributeRadios input[type="radio"]')
          .each(function () {
            const $radio = $(this);
            const isAvailable = compatible.some((variation) => {
              const variationValue = String(
                (variation.attributes || {})[attribute] || ''
              );

              return !variationValue || variationValue === $radio.val();
            });
            $radio.closest('.option').toggle(isAvailable);
            $radio.prop('disabled', !isAvailable);
          });
        $item.find(`select[name="${attribute}"] option`).each(function () {
          if (!this.value) {
            return;
          }

          const isAvailable = compatible.some((variation) => {
            const variationValue = String(
              (variation.attributes || {})[attribute] || ''
            );

            return !variationValue || variationValue === this.value;
          });
          $(this).prop('disabled', !isAvailable).toggle(isAvailable);
        });

        if (!isPresent) {
          setAttributeValue($form, attribute, '');
        } else {
          syncRadio($item, selected[attribute] || '');
        }
      });
    };

    const findSelectedVariation = ($form) => {
      const selected = selectedAttributes($form);
      const matches = getAvailableVariations($form).filter(
        (variation) =>
          variationMatches(variation, selected) &&
          Object.keys(selected).every(
            (attribute) =>
              selected[attribute] ||
              !String((variation.attributes || {})[attribute] || '')
          )
      );

      return matches.length === 1 ? matches[0] : null;
    };

    const scheduleSelectedVariation = ($form, version) => {
      const variation = findSelectedVariation($form);

      if (!variation) {
        return;
      }

      window.setTimeout(() => {
        const state = getFormState($form);
        const currentVariation = findSelectedVariation($form);
        const variationId = String(
          $form.find('input.variation_id').val() || ''
        );

        if (
          state.version === version &&
          currentVariation &&
          currentVariation.variation_id === variation.variation_id &&
          variationId !== String(variation.variation_id)
        ) {
          $form.trigger('found_variation', [variation]);
        }
      }, 0);
    };

    const notifyWooCommerce = ($form, changedAttribute) => {
      const $select = changedAttribute
        ? $form.find(`select[name="${changedAttribute}"]`)
        : $form.find('select[name^="attribute_"]').first();

      if (!$select.length) {
        return;
      }

      const state = getFormState($form);
      state.notifying = true;
      $select.trigger('change');
      state.notifying = false;
    };

    const synchronizeSelection = ($form, changedAttribute, selectFirst) => {
      const state = getFormState($form);

      state.version += 1;
      state.syncing = true;
      if (selectFirst) {
        chooseInitialVariation($form);
      }
      stabilizeSelections($form, changedAttribute);
      updateAttributeVisibility($form);
      state.syncing = false;

      notifyWooCommerce($form, changedAttribute);
      scheduleSelectedVariation($form, state.version);
    };

    const toggleSelectionError = ($item, visible) => {
      $item
        .find('.variations__item__error')
        .text(visible ? $item.attr('data-variation-error') || '' : '');
      $item
        .find('.productAttributeRadios input[type="radio"]')
        .attr('aria-invalid', visible ? 'true' : null);
    };

    // Replaces WooCommerce's alert() with inline errors on the missing groups.
    const showSelectionErrors = ($form) => {
      const $missing = $form
        .find('[data-variation-attribute]')
        .filter(function () {
          const $item = $(this);

          return $item.is(':visible') && !$item.find('select').val();
        });

      $form.find('[data-variation-attribute]').each(function () {
        toggleSelectionError($(this), $missing.is(this));
      });

      $missing
        .first()
        .find('.productAttributeRadios input[type="radio"]:enabled')
        .first()
        .trigger('focus');

      return $missing.length > 0;
    };

    variationForms.on(
      'change',
      '.productAttributeRadios input[type="radio"]',
      function () {
        const $radio = $(this);
        const $variationItem = $radio.closest('.variations__item');
        const $select = $variationItem.find('select');

        toggleSelectionError($variationItem, false);

        setAttributeValue(
          $select.closest('.variations_form'),
          $select.attr('name'),
          $radio.val()
        );
        synchronizeSelection(
          $select.closest('.variations_form'),
          $select.attr('name'),
          false
        );
      }
    );

    variationForms.on('change', 'select[name^="attribute_"]', function () {
      const $select = $(this);
      const $form = $select.closest('.variations_form');
      const state = getFormState($form);

      if (state.syncing || state.notifying) {
        syncRadio(
          $select.closest('[data-variation-attribute]'),
          $select.val() || ''
        );
        return;
      }

      synchronizeSelection($form, $select.attr('name'), false);
    });

    variationForms.each(function () {
      const $form = $(this);

      this.addEventListener(
        'click',
        (event) => {
          const addToCart = event.target.closest
            ? event.target.closest('.single_add_to_cart_button')
            : null;
          if (
            addToCart &&
            addToCart.classList.contains('wc-variation-selection-needed') &&
            showSelectionErrors($form)
          ) {
            // Capture phase: WooCommerce's delegated handler never runs.
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      synchronizeSelection($form, null, true);
    });
  });
}
